// AppointmentsPage.jsx
import { Calendar, CheckCircle2, Clock3, User, XCircle } from "lucide-react";
import { useEffect, useState } from "react";
import api from "../../../api/axios.js";

export default function AppointmentsPage() {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🔹 جلب المواعيد من Laravel
  useEffect(() => {
    api
      .get("/appointments/received")
      .then((res) => {
        setAppointments(res.data.data || []);
      })
      .catch((err) => {
        console.error("❌ فشل جلب المواعيد", err);
        setAppointments([]);
      })
      .finally(() => setLoading(false));
  }, []);

  // 🔹 تحديث حالة الحضور
  const updateAttendance = async (appointmentId, attended) => {
    try {
      const res = await api.post(`/appointments/${appointmentId}/attendance`, {
        attended,
      });

      setAppointments((prev) =>
        prev.map((appt) =>
          appt.id === appointmentId
            ? { ...appt, attended: res.data.attended }
            : appt,
        ),
      );
      alert(res.data.message);
    } catch (err) {
      alert(err.response?.data?.message || "❌ لا يمكن تحديث الحضور");
    }
  };

  // 🔹 فئة الألوان لحالة الحضور
  const attendanceBadge = (attended) => {
    if (attended === true)
      return "bg-emerald-100 text-emerald-800 ring-emerald-200";
    if (attended === false) return "bg-rose-100 text-rose-800 ring-rose-200";
    return "bg-amber-100 text-amber-800 ring-amber-200";
  };

  if (loading) return <p className="text-center mt-10">⏳ جاري التحميل...</p>;

  if (appointments.length === 0)
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="rounded-2xl bg-white p-8 text-center shadow">
          <h3 className="text-lg font-medium text-slate-700">لا توجد مواعيد</h3>
          <p className="mt-2 text-sm text-slate-500">
            بمجرد أن يقوم أحد العملاء بالحجز ستظهر هنا المواعيد.
          </p>
        </div>
      </div>
    );

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 py-12 px-4">
      <div className="mx-auto max-w-4xl">
        <header className="mb-8 flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-slate-900">المواعيد</h1>

            <p className="mt-2 text-slate-500">إدارة جميع المواعيد الواردة.</p>
          </div>

          <div className="rounded-2xl bg-white px-5 py-3 shadow">
            <p className="text-xs text-slate-500">إجمالي المواعيد</p>

            <h2 className="text-3xl font-bold">{appointments.length}</h2>
          </div>
        </header>

        <main className="space-y-4">
          {appointments.map((appt) => (
            <article
              key={appt.id}
              className="group rounded-3xl border border-slate-200 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
            >
              <div className="flex items-start gap-5">
                <div>
                  {appt.client?.image ? (
                    <img
                      src={appt.client.image}
                      alt=""
                      className="h-16 w-16 rounded-2xl object-cover"
                    />
                  ) : (
                    <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-slate-100">
                      <User size={28} />
                    </div>
                  )}
                </div>

                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <div>
                      <h2 className="text-lg font-bold">{appt.client?.name}</h2>

                      <p className="mt-1 text-slate-500">موعد العميل</p>
                    </div>

                    {appt.attended === true && (
                      <span className="rounded-full bg-green-100 px-4 py-2 text-sm font-semibold text-green-700">
                        حضر
                      </span>
                    )}

                    {appt.attended === false && (
                      <span className="rounded-full bg-red-100 px-4 py-2 text-sm font-semibold text-red-700">
                        لم يحضر
                      </span>
                    )}

                    {appt.attended === null && (
                      <span className="rounded-full bg-yellow-100 px-4 py-2 text-sm font-semibold text-yellow-700">
                        بانتظار
                      </span>
                    )}
                  </div>

                  <div className="mt-5 flex flex-wrap gap-3">
                    <div className="flex items-center gap-2 rounded-xl bg-slate-100 px-4 py-3">
                      <Calendar size={18} />
                      {appt.date}
                    </div>

                    <div className="flex items-center gap-2 rounded-xl bg-slate-100 px-4 py-3">
                      <Clock3 size={18} />
                      {appt.time}
                    </div>
                  </div>

                  {appt.attended === null && (
                    <div className="mt-6 flex gap-3">
                      <button
                        onClick={() => updateAttendance(appt.id, true)}
                        className="flex items-center gap-2 rounded-xl bg-green-600 px-5 py-3 text-white transition hover:bg-green-700"
                      >
                        <CheckCircle2 size={18} />
                        تم الحضور
                      </button>

                      <button
                        onClick={() => updateAttendance(appt.id, false)}
                        className="flex items-center gap-2 rounded-xl bg-red-500 px-5 py-3 text-white transition hover:bg-red-600"
                      >
                        <XCircle size={18} />
                        لم يحضر
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </article>
          ))}
        </main>
      </div>
    </div>
  );
}
